import React, { useState, useEffect, useCallback } from 'react';
import { adminAPI } from '../../lib/api';
import usePageTitle from '../../lib/usePageTitle';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Switch } from '../../components/ui/switch';
import { toast } from 'sonner';
import { Blocks, FileText, Flame, Wrench, Fuel, Bell, Truck } from 'lucide-react';

const ICON_MAP = {
    FileText, Flame, Wrench, Fuel, Bell, Truck, Blocks,
};

export default function AdminModulosPage() {
    usePageTitle('Gestión de Módulos');
    const [modulos, setModulos] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        try {
            const res = await adminAPI.getModulos();
            setModulos(res.data);
        } catch (err) {
            toast.error('Error cargando módulos');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const handleToggle = async (codigo) => {
        try {
            const res = await adminAPI.toggleModulo(codigo);
            toast.success(`Módulo ${codigo}: activo_global = ${res.data.activo_global}`);
            load();
        } catch (err) {
            toast.error('Error al cambiar estado');
        }
    };

    if (loading) return <div className="p-8 text-muted-foreground">Cargando módulos...</div>;

    return (
        <div className="max-w-4xl mx-auto" data-testid="admin-modulos-page">
            <div className="mb-6">
                <h1 className="text-2xl font-bold">Gestión de Módulos</h1>
                <p className="text-muted-foreground">Active o desactive módulos globalmente. Solo los módulos activos pueden asignarse a empresas.</p>
            </div>

            <div className="space-y-3">
                {modulos.map((m) => {
                    const Icon = ICON_MAP[m.icono] || Blocks;
                    return (
                        <div key={m.codigo} className="flex items-center justify-between p-4 border rounded-lg bg-card" data-testid={`modulo-${m.codigo}`}>
                            <div className="flex items-center gap-4">
                                <div className="p-2 rounded-lg bg-primary/10">
                                    <Icon className="h-6 w-6 text-primary" />
                                </div>
                                <div>
                                    <p className="font-medium">{m.nombre}</p>
                                    <p className="text-sm text-muted-foreground">{m.descripcion}</p>
                                    <p className="text-xs text-muted-foreground mt-1">Código: <code>{m.codigo}</code></p>
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <Badge variant={m.activo_global ? 'default' : 'secondary'}>
                                    {m.activo_global ? 'Activo' : 'Inactivo'}
                                </Badge>
                                <Switch
                                    checked={m.activo_global || false}
                                    onCheckedChange={() => handleToggle(m.codigo)}
                                    data-testid={`toggle-${m.codigo}`}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
